<template>
  <div
    class="item cart-item d-flex align-items-center py20-sm py15 pt0-sm bb-lightgray relative"
  >
    <div class="d-flex align-items-center f16">
      <div class="img-wrapper">
        <a :href="item.product.show_url">
          <img
            :src="
              item.product.cover_small_source ||
                'https://via.placeholder.com/130x150'
            "
            alt=""
            class="img-fluid"
          />
        </a>
      </div>
      <div class="details-wrapper px20-md pl10">
        <a :href="item.product.show_url">
          <p
            class="mb20-md mb10 fs14 fs16-md fs20-lg title product-title main-link text-left"
          >
            {{ item.product.title }}
          </p>
        </a>
        <p class="mb20-md mb10 variant">
          <template v-for="(variation, index) in item.variations">
            <strong :key="index" class="ff-nunito-bold">
              {{ variation.variation.title }}:
            </strong>
            {{ variation.value.title }},
          </template>
        </p>
        <p class="mb20-md mb10 fs14 fs16-md fs20-lg ff-nunito-bold">
          {{ item.unit_price | moneyToCurrencyFormat }}
        </p>
        <ValidationProvider
          :rules="{
            required: true,
            min_value: 1,
            max_value: item.stock_quantity
          }"
          ref="quantityInput"
          name="quantity"
          v-slot="{ errors }"
          slim
        >
          <cart-qty-input
            :max="item.stock_quantity"
            v-model="quantity"
            @input="updateItemQuantity"
          />
          <span v-if="errors.length > 0" class="label--error text-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <div class="remove pt10 pb0 px10-sm px0 tc-grey" @click="removeItem">
          <span class="d-sm-none fs14">
            Remove
          </span>
          <i class="d-sm-block d-none fa fa-times" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartQtyInput from "./CartQtyInput";
import { ValidationProvider } from "vee-validate";

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      quantity: this.item.quantity
    };
  },
  components: {
    CartQtyInput,
    ValidationProvider
  },
  methods: {
    removeItem() {
      this.$store.dispatch("cart/remove", this.item.id);
    },
    async updateItemQuantity() {
      const isValid = await this.$refs.quantityInput.validate();

      if (!isValid) {
        return;
      }

      this.$store.dispatch("cart/updateQuantity", {
        id: this.item.id,
        quantity: this.quantity
      });
    }
  }
};
</script>

<style scoped>
.img-wrapper {
  width: 160px;
}

.img-wrapper img {
  border: 1px solid transparent;
  max-width: 160px;
  object-fit: cover;
}

.qty-block {
  max-width: 130px;
}

@media screen and (max-width: 375px) {
  .img-wrapper {
    width: 125px;
  }
  .img-wrapper img {
    max-width: 125px;
  }
}
</style>
